import {
    acurisButtonBackgroundColour,
    highlightColour,
    neutralTertiaryButtonBackgroundColour,
    neutralTertiaryButtonBorderColour,
    neutralTertiaryButtonHoverBackgroundColour,
    neutralTertiaryButtonTextColour,
    primaryButtonShadowColour,
    secondaryButtonShadowColour,
    secondaryHighlightColour,
    triggerColour
} from "../../style/styleConsts";
import styled from "styled-components";
import React from "react";

const BaseButton = styled.a`
    font-weight: bold;
    font-size: 13px;
    
    white-space: nowrap;
    text-decoration: none;
    padding: 0px 15px;
    line-height: 32px;
    height: 32px;
    box-sizing: border-box;
    display: inline-block;
    border-radius: 3px;
    transition: background-color 0.2s ease;
    cursor: pointer;
    
    :active {
        box-shadow: inset 0 2px 3px 0 rgba(0,0,0,0.25);
    }
`;

export const PrimaryButton = styled(BaseButton)`
    background-color: ${triggerColour};
    color: white;
    border: 1px solid ${triggerColour};
    box-shadow: 0 3px 1px 0 ${primaryButtonShadowColour};
    
    :hover {
        background-color: ${highlightColour};
    }
`;

export const SecondaryButton = styled(BaseButton)`
    align-self: center;
    background: ${acurisButtonBackgroundColour};
    color: #fff;
    border: solid 1px transparent;
    border-radius: .3rem;
    box-shadow: 0 3px 1px 0 ${secondaryButtonShadowColour};
    margin-top: 10px;
    text-align: center;
    display: flex;

    :hover {
        background-color: ${secondaryHighlightColour};
    }
`;

export const NeutralTertiaryButton = styled(BaseButton)`
    background-color: ${neutralTertiaryButtonBackgroundColour};
    color: ${neutralTertiaryButtonTextColour};
    border: 1px solid ${neutralTertiaryButtonBorderColour};
    
    :hover {
        background-color: ${neutralTertiaryButtonHoverBackgroundColour};
    }
`;
